"use client";

import { useLocale } from "@/lib/i18n";
import { localizedCaseDeepCopy } from "@/lib/case-studies/localizations";

type Field = "lede" | "problem" | "approach" | "outcome";

type Props = {
  slug: string;
  field: Field;
  /** EN canonical fallback */
  fallback: string;
};

/**
 * Renders a single deep-copy field for the case page, swapping to SQ/AR
 * if a translation exists. Falls back to EN canonical otherwise. SSR
 * always renders EN; locale swap happens after hydration.
 */
export function CaseDeepCopy({ slug, field, fallback }: Props) {
  const { locale } = useLocale();
  const localized = localizedCaseDeepCopy(slug, locale);
  return <>{localized?.[field] ?? fallback}</>;
}
